import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import "./product-update-modal.css";
import { PiX } from "react-icons/pi";

const STORYLANE_SCRIPT_SRC = "https://js.storylane.io/js/v2/storylane.js";

function useStorylaneScript(visible) {
    useEffect(() => {
        if (!visible) return;
        const existing = document.querySelector(`script[src="${STORYLANE_SCRIPT_SRC}"]`);
        if (existing) return;
        const script = document.createElement("script");
        script.async = true;
        script.src = STORYLANE_SCRIPT_SRC;
        document.body.appendChild(script);
    }, [visible]);
}

const embedWrapStyle = {
    position: "relative",
    paddingBottom: "calc(57.27% + 25px)",
    width: "100%",
    height: 0,
    transform: "scale(1)",
};

const iframeStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    border: "1px solid rgba(63, 95, 172, 0.35)",
    boxShadow: "0px 0px 18px rgba(26, 19, 72, 0.15)",
    borderRadius: 10,
    boxSizing: "border-box",
};

function DefaultStorylaneEmbed() {
    return (
        <div className="product-update-modal__embed">
            <div className="sl-embed" style={embedWrapStyle}>
                <iframe
                    loading="lazy"
                    className="sl-demo"
                    title="Product updates walkthrough"
                    src="https://app.storylane.io/demo/44rsju2ywfqk?embed=inline"
                    name="sl-embed"
                    allow="fullscreen"
                    allowFullScreen
                    style={iframeStyle}
                />
            </div>
        </div>
    );
}

/**
 * Large-width centered modal. Optional `children`; otherwise shows Storylane embed.
 */
export default function ProductUpdateModal({
    show = false,
    onHide,
    title = "Product update",
    children,
    footer = null,
    centered = true,
    backdrop = true,
}) {
    useStorylaneScript(show);

    return (
        <Modal
            className="product-update-modal"
            show={show}
            onHide={typeof onHide === "function" ? onHide : () => { }}
            centered={centered}
            backdrop={backdrop}
            keyboard
            dialogClassName="product-update-modal__dialog"
            aria-labelledby="product-update-modal-title"
        >
            <div className="closeIconModal" onClick={onHide}>
                <PiX size={20} />
            </div>
            <Modal.Body className="product-update-modal__body">
                {children != null && children !== false ? children : <DefaultStorylaneEmbed />}
            </Modal.Body>
        </Modal>
    );
}
